<script setup>
const props = defineProps({
  fillColor: { type: String, default: '#fff' },
})
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.4 2.39844C7.07452 2.39844 6 3.47295 6 4.79844V19.1984C6 20.5239 7.07452 21.5984 8.4 21.5984H15.6C16.9255 21.5984 18 20.5239 18 19.1984V4.79844C18 3.47295 16.9255 2.39844 15.6 2.39844H8.4ZM12 19.1984C12.6627 19.1984 13.2 18.6612 13.2 17.9984C13.2 17.3357 12.6627 16.7984 12 16.7984C11.3373 16.7984 10.8 17.3357 10.8 17.9984C10.8 18.6612 11.3373 19.1984 12 19.1984Z"
      :fill="fillColor"
    />
  </svg>
</template>
